<template>
	<div class="password-toggle">
		<label :for="name" class="label">Password</label>
		<div class="password-toggle__container">
			<input
				class="password-toggle__input"
				@input="$emit('input', $event.target.value)"
				:type="fieldType"
				:name="name"
				:value="value"
				v-bind="$attrs"
			/>
			<a
				role="button"
				class="password-toggle__button type--sans type--b type--xs"
				@click="toggleVisible"
			>{{ buttonText }}</a>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			passwordVisible: false
		}
	},

	props: {
		name: {
			type: String,
			default: "password"
		},
		value: {
			type: String,
			default: ""
		}
	},

	name: "PasswordField",

	computed: {
		buttonText() {
			return this.passwordVisible ? "HIDE" : "SHOW"
		},
		fieldType() {
			return this.passwordVisible ? "text" : "password"
		}
	},

	methods: {
		toggleVisible() {
			this.passwordVisible = !this.passwordVisible
		},
	}
}
</script>

<style lang="scss" scoped>
.password-toggle__container {
	position: relative;
}

.password-toggle__input {
	padding-right: 3.25rem;
}

.password-toggle__button {
	align-items: center;
	background: transparent;
	border-radius: 0.125rem;
	bottom: 0.125rem;
	color: $colour-pencil;
	display: inline-flex;
	justify-content: center;
	letter-spacing: 0.1em;
	right: 0.125rem;
	padding: 0.125rem 0.625rem 0;
	position: absolute;
	top: 0.125rem;
}
</style>